import React, { useRef, useState } from "react";

export default function BeforeAfter({ before, after, label = "Before / After" }) {
  const ref = useRef(null);
  const [pos, setPos] = useState(50);

  const onMove = (e) => {
    const rect = ref.current.getBoundingClientRect();
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const x = Math.min(Math.max(clientX - rect.left, 0), rect.width);
    setPos((x / rect.width) * 100);
  };

  return (
    <div
      ref={ref}
      data-testid="before-after"
      className="relative w-full aspect-[16/10] overflow-hidden select-none cursor-ew-resize"
      onMouseMove={(e) => e.buttons === 1 && onMove(e)}
      onTouchMove={onMove}
      onClick={onMove}
    >
      <img src={after} alt="After" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 overflow-hidden" style={{ width: `${pos}%` }}>
        <img src={before} alt="Before" className="absolute inset-0 w-full h-full object-cover" style={{ width: `calc(100% * ${100 / Math.max(pos, 0.0001)})` }} />
      </div>
      <div className="absolute top-4 left-4 label text-bone bg-ink/70 px-2 py-1">Before</div>
      <div className="absolute top-4 right-4 label text-bone bg-rust/90 px-2 py-1">After</div>
      <div className="absolute top-0 bottom-0 w-px bg-bone" style={{ left: `${pos}%` }}>
        <div className="absolute top-1/2 -translate-y-1/2 -left-5 w-10 h-10 rounded-full bg-bone text-ink flex items-center justify-center shadow-lg">⇆</div>
      </div>
      <p className="absolute bottom-4 left-4 label text-bone bg-ink/70 px-2 py-1">{label}</p>
    </div>
  );
}
